<template>
  <div class="AddProductionCategory">
    <el-dialog
        title="新增分类"
        :visible.sync="visible"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
    >
      <el-form ref="form" :model="formData" :rules="rules">
        <el-form-item label="名称" prop="name">
          <el-input v-model="formData.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="显示课包数量" prop="size">
          <el-input v-model="formData.size" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleConfirm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {mapActions} from "vuex";

export default {
  name: "AddProductionCategory",
  components: {},
  props: {},
  data() {
    return {
      visible: false,
      formData: {
        size: 3,
      },
      rules: {
        name: {
          required: true,
          message: "请输入分类名称",
          trigger: ["blur"],
        },
        size: {
          required: true,
          pattern: /^[0-9]$/,
          message: "请输入数字",
          trigger: ["blur"],
        },
      }
    };
  },
  computed: {},
  async mounted() {
  },
  methods: {
    ...mapActions("teachingCenter", ["saveProductCategory", "getProductCategoryList"]),
    handleConfirm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.saveProductCategory(this.formData).then(() => {
            this.getProductCategoryList({});
            this.visible = false;
          });
        }
      });

    },
    initData(data) {
      if (data) {
        this.formData = {...data}
      } else {
        this.formData = this.defaultFormData();
      }
    },
    defaultFormData() {
      return {
        size: 3,
        name: null,
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.AddProductionCategory {

}
</style>
